<script>
export default {
  props: ["clr", "backClr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g id="approve" transform="translate(-1520 -139.006)">
      <circle
        id="Ellipse_135"
        data-name="Ellipse 135"
        cx="11"
        cy="11"
        r="11"
        transform="translate(1520 139.006)"
        :fill="backClr ? backClr : 'rgba(0,185,71,0.08)'"
      />
      <g id="pass_check" transform="translate(1523 142.006)">
        <path
          id="Path_1488"
          data-name="Path 1488"
          d="M0,0H16V16H0Z"
          fill="none"
        />
        <path
          id="checkbox_check"
          d="M21.547,11.5l1.507,1.507L16.031,20.04,11.5,15.519l1.507-1.507,3.024,3.014Z"
          transform="translate(-9.5 -7.5)"
          :fill="clr ? clr : '#00b947'"
        />
      </g>
    </g>
  </svg>
</template>
